import {StyleSheet} from 'react-native';

export const createStyles = (gameTheme: any, isDarkTheme: boolean) => {
  const {
    textColorPrimary,
    textColorSecondary,
    textColorTertiary,
    fontRegular,
    fontSizeH4,
    fontSizeH5,
  } = gameTheme ?? {};

  return StyleSheet.create({
    container: {
      flex: 1,
      // position: 'relative',
    },
    backIcon: {
      width: 24,
      height: 24,
    },
    infoIcon: {
      width: 24,
      height: 24,
    },
    header: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingHorizontal: 20,
      paddingTop: 10,
      paddingBottom: 24,
    },
    orContinueWithContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: 16,
    },
    orContinueWithText: {
      ...fontRegular,
      ...fontSizeH4,
      ...textColorTertiary,
      marginHorizontal: 10,
      textAlign: 'center',
    },
    line: {
      width: 90,
      height: 3,
    },

    normalText: {
      ...fontRegular,
      ...fontSizeH5,
      ...textColorTertiary,
      textAlign: 'center',
    },
    linkText: {
      ...fontRegular,
      ...fontSizeH5,
      ...textColorTertiary,
      textDecorationLine: 'underline',
    },
    socialButtonsContainer: {
      flexDirection: 'row',
      justifyContent: 'center',
      marginHorizontal: 20,
      marginTop: 24,
      marginBottom: 32,
      gap: 16,
    },
    socialButton: {
      // flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: isDarkTheme ? 'rgba(255, 255, 255, 0.90)' : 'rgba(0, 0, 0, 0.80)',
      opacity: 0.86,
      borderRadius: 16,
      paddingVertical: 12,
      paddingHorizontal: 10,
      shadowOffset: {
        width: 1,
        height: 1,
      },
      shadowColor: 'rgba(0, 0, 0, 0.25)',
      shadowOpacity: 1,
      shadowRadius: 6,
      elevation: 2,
    },
    socialIcon: {
      width: 20,
      height: 20,
      marginRight: 6,
    },
    socialButtonText: {
      fontWeight: '700',
      ...fontSizeH4,
      // ...textColorPrimary,
      color: isDarkTheme ? 'black' : 'white',
    },
    tosView: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 999,
    },
    // New styles for previously inline styles
    signUpContainerNewUI: {
      marginTop: 24,
    },
    signUpContainerOldUI: {
      backgroundColor: '#ffffff',
      height: '100%',
      width: '100%',
      paddingTop: 1,
    },
    headerContainerStyle: {
      justifyContent: 'center',
    },
    scrollViewContent: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      width: '80%',
      alignSelf: 'center',
      flexGrow: 1,
    },
    bottomPaddingContainer: {
      paddingBottom: 38,
    },
    loginWithText: {
      fontSize: 16,
      fontWeight: '700',
      fontStyle: 'normal',
      fontFamily: 'Open Sans',
      textDecorationColor: textColorPrimary.color,
      textDecorationLine: 'underline',
      color: textColorPrimary.color,
      textAlign: 'center',
      marginTop: 20,
    },
    tosHeaderContainer: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: 20,
    },
    tosTitleText: {
      fontSize: 18,
      fontWeight: 'bold',
      color: isDarkTheme ? textColorPrimary.color : textColorSecondary.color,
    },
    tosCloseText: {
      fontSize: 16,
      color: '#4890E8',
      fontWeight: '600',
    },
    bannerContainer: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
    },
    pushButtonText: {
      fontWeight: '700',
      fontSize: 18,
    },
    pushButtonStyle: {
      height: 56,
    },
    loadingIndicatorContainer: {
      ...StyleSheet.absoluteFillObject,
      top: 70,
    },
  });
};
